import React from 'react';
import {Toast, ToastContainer} from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';

function ToastIt({ Variance, Message, ShowToast, OnClose }) {

  return (
<ToastContainer className="p-3 d-inline-block m-1 position-fixed" position='top-center' style={{ zIndex: 9999 }} >
<Toast bg={Variance || "warning"}  onClose={OnClose} show={ShowToast} delay={3000} autohide>
  <Toast.Header closeButton={false}>
    <InfoCircle/>
    <strong className="me-auto">Notification</strong>
    {/* <small>11 mins ago</small> */}
  </Toast.Header>
  <Toast.Body className='text-white'>{Message}</Toast.Body>
</Toast>
</ToastContainer>
  );
}

export default ToastIt;

